<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="true"
  (devolverAccion)="downloadDataCsv()">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <div class="w-100"></div>
  <div [formGroup]="FormFiltros" novalidate class="form-group">
    <div class="row align-items-center">
      <div class="col-md-9">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbMeses" 
          [formControlName]="modelGrid.mes" [control]="this.CURRENT_MONTH" [label]="'Mes*'" [id]="'mes'">
        </app-lfsa-combo-box>
      </div>
      <div class="col-md-3">
        <p>Solo puede gestionar la última versión activa.</p>
        <span>Registros para Anio Actual: {{CURRENT_YEAR}} | Mes Actual: {{CURRENT_MONTH}}.</span>
      </div>
    </div>
  </div>
  <hr>
  <div class="w-100"></div>

  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-9">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-md-3">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>

  <br>
  
  <div class="row">
    <div class="col-md-12">
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" 
                        [id]="modulo.agGrid.id"
                        [class]="modulo.agGrid.class" 
                        [ngStyle]="modulo.agGrid.style" 
                        [columnDefs]="columnDefs" 
                        [floatingFilter]="true" 
                        [frameworkComponents]="frameworkComponents"                      
                        [paginationPageSize]="modulo.agGrid.paginacion"
                        [pagination]="true"
                        [rowSelection]="rowSelection"
                        [rowData]="rowData">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <!-- {{ formulario.value | json }} -->
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Version'"
            [label]="'Version *'" [id]="'descripcionVersion'" formControlName="descripcionVersion"
            [control]="formulario.get('descripcionVersion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbTipoDePresupuesto" formControlName="tipoPresupuesto"
          [control]="formulario.get('tipoPresupuesto')" [label]="'Tipo de Presupuesto *'" [id]="'tipoPresupuesto'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box (change)="changeTipoDocumento()" [claseLabel]="'letrasDanger'" [opcion]="'nombreCanalVenta'"
          [idOpcion]="'codigoDireccion'" [comboBox]="cmbTipoDocumento" formControlName="tipo"
          [control]="formulario.get(modelGrid.tipo)" [label]="'Tipo Documento*'" [id]="'tipoDocumento'">
        </app-lfsa-combo-box>
      </div>
      <div class="w-100"></div>

      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true"  [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Usuario'"
          [label]="'Usuario Actual'" [id]="'usuario'" [formControlName]="modelGrid.usuario" [control]="formulario.get(modelGrid.usuario)">
        </app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Número del Año'"
          [label]="'Año*'" [id]="'anio'" [formControlName]="modelGrid.anio"
          [control]="formulario.get(modelGrid.anio)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbMeses"
          [formControlName]="modelGrid.mes" [control]="formulario.get(modelGrid.mes)" [label]="'Mes*'" [id]="'mes'">
        </app-lfsa-combo-box>
      </div>
    </div>
    
    <div class="w-100"></div>
    <div class="row">
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código del Vendedor'"
          [label]="'Vendedor*'" [id]="'codigoVendedor'" [formControlName]="modelGrid.codigoVendedor"
          [control]="formulario.get(modelGrid.codigoVendedor)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código del Cliente (9 digitos)'" 
          [label]="'Cliente*'" [id]="'codigoCliente'" [formControlName]="modelGrid.codigoCliente"
          [control]="formulario.get(modelGrid.codigoCliente)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código del Articulo'"
          [label]="'Articulo*'" [id]="'codigoArticulo'" [formControlName]="modelGrid.codigoArticulo"
          [control]="formulario.get(modelGrid.codigoArticulo)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Número de Cajas'"
          [label]="'Cajas*'" [id]="'cajas'" [formControlName]="modelGrid.cajas"
          [control]="formulario.get(modelGrid.cajas)"></app-lfsa-input>
      </div>
    </div>
    
    <div class="w-100"></div>
    <div class="row">
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el peso en Kilos'"
          [label]="'Kilos*'" [id]="'kilos'" [formControlName]="modelGrid.kilos"
          [control]="formulario.get(modelGrid.kilos)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        Venta Neta debe ser menor o igual a Venta Bruta: <!-- {{ dolaresMayorQueVentaBruta }} -->
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el monto en Dolares'"
          [label]="'Venta Neta*'" [id]="'dolares'" [formControlName]="modelGrid.dolares"
          [control]="formulario.get(modelGrid.dolares)"></app-lfsa-input>
          <div *ngIf="dolaresMayorQueVentaBruta" style="color: red;">
            El campo Venta Neta no puede ser mayor al campo Venta Bruta.
          </div>
      </div>
      <div class="form-group col-12 col-md-3">
        Venta bruta debe ser mayor a Venta Neta <!-- {{ ventaBrutaMenorQueDolares }}-->
        <app-lfsa-input appTwoDigitDecimaNumber (keypress)="keyOnly2deciamls($event)" [type]="'number'"
          [class]="'letrasDanger'" [placeholder]="'Venta bruta'" [label]="'Venta bruta *'" [id]="'ventaBruta'"
          formControlName="ventaBruta" [control]="formulario.get('ventaBruta')"></app-lfsa-input>
          <div *ngIf="ventaBrutaMenorQueDolares" style="color: red;">
            El campo venta bruta no puede ser menor al campo Dólares.
          </div>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el monto en Dolares(MTV)'"
          [label]="'MTV*'" [id]="'mtv'" [formControlName]="modelGrid.mtv"
          [control]="formulario.get(modelGrid.mtv)"></app-lfsa-input>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>

</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Presupuesto'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <!-- {{ formulario.value | json }} -->
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-3">
        <h5>Tipo: {{ formulario.get('tipo').value + formulario.get('descripcionCanal').value }}</h5>
      </div>
      <div class="form-group col-12 col-md-3">
        <h5>Usuario : {{ usuario }}</h5>
      </div>
      <div class="form-group col-12 col-md-3">
        <h5>Año: {{ formulario.get(modelGrid.anio).value }}</h5>
      </div>
      <div class="form-group col-12 col-md-3">
        <!-- <h5>Mes: {{ formulario.get(modelGrid.mes).value }}</h5> -->
        <h5>Mes: {{ mesDescripcion }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <h5>Cod. Vendedor: {{ formulario.get(modelGrid.codigoVendedor) .value}}</h5>
      </div>
      <div class="form-group col-12 col-md-4">
        <h5>Cod. Cliente: {{ formulario.get(modelGrid.codigoCliente) .value}}</h5>
      </div>
      <div class="form-group col-12 col-md-4">
        <h5>Cod. Articulo: {{ formulario.get(modelGrid.codigoArticulo) .value}}</h5>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Versión'"
          [label]="'Versión *'" [id]="'descripcionVersion'" formControlName="descripcionVersion"
          [control]="formulario.get('descripcionVersion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Tipo de Presupuesto'"
          [label]="'Tipo de Presupuesto *'" [id]="'descripcionTipoPresupuesto'" formControlName="descripcionTipoPresupuesto"
          [control]="formulario.get('descripcionTipoPresupuesto')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        ventaBrutaMenorQueDolares: {{ ventaBrutaMenorQueDolares }}
        <app-lfsa-input appTwoDigitDecimaNumber (keypress)="keyOnly2deciamls($event)" [type]="'number'"
          [class]="'letrasDanger'" [placeholder]="'Venta bruta'" [label]="'Venta bruta *'" [id]="'ventaBruta'"
          formControlName="ventaBruta" [control]="formulario.get('ventaBruta')"></app-lfsa-input>
          <div *ngIf="ventaBrutaMenorQueDolares" style="color: red;">
            El campo venta bruta no puede ser menor al campo Dólares.
          </div>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Número de Cajas'"
          [label]="'Cajas*'" [id]="'cajas'" [formControlName]="modelGrid.cajas"
          [control]="formulario.get(modelGrid.cajas)"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el peso en Kilos'"
          [label]="'Kilos*'" [id]="'kilos'" [formControlName]="modelGrid.kilos"
          [control]="formulario.get(modelGrid.kilos)"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el monto en Dolares'"
          [label]="'Dolares*'" [id]="'dolares'" [formControlName]="modelGrid.dolares"
          [control]="formulario.get(modelGrid.dolares)"></app-lfsa-input>
          <div *ngIf="dolaresMayorQueVentaBruta" style="color: red;">
            El campo Dólares no puede ser mayor al campo Venta Bruta.
          </div>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese el monto en Dolares(MTV)'"
          [label]="'MTV*'" [id]="'mtv'" [formControlName]="modelGrid.mtv"
          [control]="formulario.get(modelGrid.mtv)"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-12">
        <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
          (click)="actualizar()">Guardar</button>
      </div>
    </div>
  </div>
</ng-template>